const getEnvType = () => {
    if(process.env.NODE_ENV === "development") {
        // This is what we get when we're running the app in webpack dev mode - without AGG
        return "DEV_SERVER"
    }

    if(window.location.href.includes("localhost")) {
        // We're using a production bundle of the frontend app - so not in development mode when it comes
        // to webpack. This occurs when we're running AGG locally.
        return "LOCAL";
    }

    if (window.location.hostname.includes("dev")) {
        return "DEV";
    }

    if(window.location.hostname.includes("stg")) {
        return "STAGING";
    }

    return "PROD";
}

const getGraphQLEndpoint = envType => {
    if (envType === "DEV_SERVER") {
        return "https://api.stg.atlassian.com/graphql";
    }

    return window.location.href;
}

const getEnvironment = () => {
    const envType = getEnvType();
    const graphQLEndpoint = getGraphQLEndpoint(envType);
    const graphQLSubscriptionEndpoint = new URL(graphQLEndpoint + "/subscriptions")
    graphQLSubscriptionEndpoint.protocol = "wss"

    return {
        envType,
        graphQLEndpoint,
        graphQLSubscriptionEndpoint
    }
}

export default getEnvironment;
